export type HandleType = 'start' | 'end';
export type DragTarget = HandleType | 'range' | null;

export const HANDLE_WIDTH = 40;
export const THUMB_WIDTH = 4;
export const BAR_HEIGHT = 38;
